import { Moment } from 'moment';
import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import FormContainer from '../../../../../../Components/Form/FormContainer';
import TimePickerField from '../../../../../../Components/Form/components/TimePickerField/TimePickerField';
import Text from '../../../../../../Components/Base/Text/Text';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import styles from './ManagerCalendarWorkingHoursWeekly.module.scss';

export interface WholeWeekValues {
	morning?: {
		timeFrom?: Moment | null;
		timeTo?: Moment | null;
	};
	afternoon?: {
		timeFrom?: Moment | null;
		timeTo?: Moment | null;
	};
}

interface Props {
	onSubmit: (values: WholeWeekValues) => void;
}

const ManagerCalendarWorkingHoursWeekly: React.FC<Props> = ({ onSubmit }) => {
	const formMethods = useForm<WholeWeekValues>();

	const timePickerStyle: React.CSSProperties = {
		marginBottom: 0,
		width: '100px',
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className={styles.dayParts}>
				<FormContainer name='morning'>
					<div className={styles.times}>
						<Text tx='base.shared.from' />
						<TimePickerField name='timeFrom' style={timePickerStyle} portal />
						<Text tx='base.shared.to' />
						<TimePickerField name='timeTo' style={timePickerStyle} portal />
					</div>
				</FormContainer>
				<div className={styles.line} />
				<FormContainer name='afternoon'>
					<div className={styles.times}>
						<Text tx='base.shared.from' />
						<TimePickerField name='timeFrom' style={timePickerStyle} portal />
						<Text tx='base.shared.to' />
						<TimePickerField name='timeTo' style={timePickerStyle} portal />
					</div>
				</FormContainer>
			</div>
			<div className={styles.footer}>
				<SubmitButton
					onSubmit={onSubmit}
					title='component.managerCalendarWorkingHoursWeekly.prefill'
				/>
			</div>
		</FormWrapper>
	);
};

export default ManagerCalendarWorkingHoursWeekly;
